import { defineMessages } from 'react-intl';

export default defineMessages({
    whatTitle: {
        id: 'tdic.fnol.wizard.step.wc7.What',
        defaultMessage: 'What'
    },
    dateSelect: {
        id: 'tdic.fnol.wizard.step.wc7.what.date-select.Please Select',
        defaultMessage: 'Please Select'
    },
    wcWhereTitle: {
        id: 'tdic.fnol.wizard.step.wc7.Where',
        defaultMessage: 'Where'
    },
    wcInjuryTitle: {
        id: 'tdic.fnol.wizard.step.wc7.Injury',
        defaultMessage: 'Injury'
    },
    wcInjuryDetails: {
        id: 'tdic.fnol.wc7.views.injury.Injury Details',
        defaultMessage: 'Injury Details'
    },
    wcInjuryType: {
        id: 'tdic.fnol.wc7.views.injury.Injury Type',
        defaultMessage: 'Injury Type'
    },
    wcSelectInjuryType: {
        id: 'tdic.fnol.wc7.views.injury.Select injury type',
        defaultMessage: '-- Select injury type --'
    },
    wcInjuryDescription: {
        id: 'tdic.fnol.wc7.views.injury.Injury Description',
        defaultMessage: 'Injury Description'
    },
    wcInjuryResultDeath: {
        id: 'tdic.fnol.wc7.views.injury.Injury/illness result in death?',
        defaultMessage: 'Injury/illness result in death?'
    },
    wcInjuryWorkTimeLost: {
        id: 'tdic.fnol.wc7.views.injury.Lost time from work?',
        defaultMessage: 'Lost time from work?'
    },
    wcInjuryMedicalTreatment: {
        id: 'tdic.fnol.wc7.views.injury.Medical Treatment',
        defaultMessage: 'Medical Treatment'
    },
    wcInjuryMedicalAttentionRequired: {
        id: 'tdic.fnol.wc7.views.injury.Medical attention required?',
        defaultMessage: 'Medical attention required?'
    },
    wcInjuryExaminationDate: {
        id: 'tdic.fnol.wc7.views.injury.Examination Date',
        defaultMessage: 'Examination Date'
    },
    wcInjuryDoctorFirstName: {
        id: 'tdic.fnol.wc7.views.injury.Doctor\'s_First Name',
        defaultMessage: 'Doctor\'s First Name'
    },
    wcInjuryDoctorLastName: {
        id: 'tdic.fnol.wc7.views.injury.Doctor\'s_Last Name',
        defaultMessage: 'Doctor\'s Last Name'
    },
    wcInjuryDoctorFirstNameKanji: {
        id: 'tdic.fnol.wc7.views.injury.Doctor\'s_First Name Kanji',
        defaultMessage: 'Doctor\'s First Name Kanji'
    },
    wcInjuryDoctorLastNameKanji: {
        id: 'tdic.fnol.wc7.views.injury.Doctor\'s_Last Name Kanji',
        defaultMessage: 'Doctor\'s Last Name Kanji'
    },
    wcInjuryBodyInjuries: {
        id: 'tdic.fnol.wc7.views.injury.Injuries',
        defaultMessage: 'Injuries'
    },
    wcInjuryAdditionalBodyInjury: {
        id: 'tdic.fnol.wc7.views.injury.Additional body injury?',
        defaultMessage: 'Additional body injury?'
    },
    wcInjuryAddAnotherBodyInjury: {
        id: 'tdic.fnol.wc7.views.injury.Add Another Body Injury',
        defaultMessage: 'Add Another Body Injury'
    },
    wcInjuryBodyArea: {
        id: 'tdic.fnol.wc7.views.injury.Body Area',
        defaultMessage: 'Body Area #{bodyAreaCount}'
    },
    wcInjuryAreaOfBody: {
        id: 'tdic.fnol.wc7.views.injury.Area of Body',
        defaultMessage: 'Area of Body'
    },
    wcInjurySelectAreaOfBody: {
        id: 'tdic.fnol.wc7.views.injury.Select Area of Body',
        defaultMessage: '-- Select Area of Body --'
    },
    wcInjuryBodyPart: {
        id: 'tdic.fnol.wc7.views.injury.Body Part',
        defaultMessage: 'Body Part'
    },
    wcInjurySelectBodyPart: {
        id: 'tdic.fnol.wc7.views.injury.Select Body Part',
        defaultMessage: '-- Select Body Part --'
    },
    wcInjuryBodyPartDescription: {
        id: 'tdic.fnol.wc7.views.injury.Body Part Description',
        defaultMessage: 'Body Part Description'
    },
    wcInjurySelectBodyPartDescription: {
        id: 'tdic.fnol.wc7.views.injury.Select Body Part Description',
        defaultMessage: '-- Select Body Part Description --'
    },
    wcInjurySide: {
        id: 'tdic.fnol.wc7.views.injury.Side',
        defaultMessage: 'Side'
    },
    wcInjurySelectSide: {
        id: 'tdic.fnol.wc7.views.injury.Select Side',
        defaultMessage: '-- Select Side --'
    },
    wcInjuryRemoveBodyInjury: {
        id: 'tdic.fnol.wc7.views.injury.Remove Body Injury',
        defaultMessage: 'Remove Body Injury'
    },
    wcInjuryModalRemoveBodyInjury: {
        id: 'tdic.fnol.wc7.views.injury.Are you sure you want to remove Body Injury #: {bodyPartDetail}?',
        defaultMessage: 'Are you sure you want to remove Body Injury #: {bodyPartDetail}?'
    },
    wcInjuryRemoveButton: {
        id: 'tdic.fnol.wc7.views.injury.Remove',
        defaultMessage: 'Remove'
    },
    wcInjuryOccurredInCourseOfEmployment: {
        id: 'tdic.fnol.wc7.views.injury.Did the injury occur in course of Employment?',
        defaultMessage: 'Did the injury occur in course of Employment?'
    },
    wcCreateDraftClaim: {
        id: 'tdic.fnol.wc7.config.FlowConfig.Creating draft claim...',
        defaultMessage: 'Creating draft claim...'
    },
    wcCreateDraftErrorTitle: {
        id: 'tdic.fnol.wc7.config.FlowConfig.Error creating claim',
        defaultMessage: 'Error creating claim'
    },
    wcCreateDraftErrorMessage: {
        id: 'tdic.fnol.wc7.config.FlowConfig.An error occurred attempting to create a claim.',
        defaultMessage: 'An error occurred attempting to create a claim.'
    },
    describeWhatHappendTitle: {
        id: 'tdic.fnol.wc7.views.what.Describe what happened',
        defaultMessage: 'Describe what happened'
    },
    causeOfInjury: {
        id: 'tdic.fnol.wc7.views.what.Cause of Injury/Source',
        defaultMessage: 'Cause of Injury/Source'
    },
    selectInjuryCauseSourceLabel: {
        id: 'tdic.fnol.wc7.views.what.Select Injury Cause/Source',
        defaultMessage: '-- Select Injury Cause/Source --'
    },
    howInjuryOccurred: {
        id: 'tdic.fnol.wc7.views.what.Description of injury/incident',
        defaultMessage: 'Description of injury/incident'
    },
    detailCauseOfIncidentLabel: {
        id: 'tdic.fnol.wc7.views.what.Indicate who or what caused the incident, and provide other details that would be helpful.',
        defaultMessage: 'Indicate who or what caused the incident, and provide other details that would be helpful.'
    },
    employerNotified: {
        id: 'tdic.fnol.wc7.views.what.When did you become aware of the injury?',
        defaultMessage: 'When did you become aware of the injury?'
    },
    submitAsReportLabel: {
        id: 'tdic.fnol.wc7.views.what.Submit as report only?',
        defaultMessage: 'Submit as report only?'
    },
    dateEmployerNotifiedLabel: {
        id: 'tdic.fnol.wc7.views.what.Date Employer Notified',
        defaultMessage: 'Date Employer Notified'
    },
    injuredEmployeeLabel: {
        id: 'tdic.fnol.wc7.views.what.Injured employee',
        defaultMessage: 'Injured employee'
    },
    injuryCauseSourceLabel: {
        id: 'tdic.fnol.wc7.views.what.Injury Cause/Source',
        defaultMessage: 'Injury Cause/Source'
    },
    firstNameLabel: {
        id: 'tdic.fnol.wc7.views.what.First Name',
        defaultMessage: 'First Name'
    },
    lastNameLabel: {
        id: 'tdic.fnol.wc7.views.what.Last Name',
        defaultMessage: 'Last Name'
    },
    employeePhoneNumber: {
        id: 'tdic.fnol.wc7.views.what.Employee Phone Number',
        defaultMessage: 'Employee Phone Number'
    },
    phoneNumberLabel: {
        id: 'tdic.fnol.wc7.views.what.Phone Number',
        defaultMessage: 'Phone Number'
    },
    socialSecurityNumberLabel: {
        id: 'tdic.fnol.wc7.views.what.Social Security Number',
        defaultMessage: 'Social Security Number'
    },
    emailAddress: {
        id: 'tdic.fnol.wc7.views.what.Email Address',
        defaultMessage: 'Email Address'
    },
    dateOfBirthLabel: {
        id: 'tdic.fnol.wc7.views.what.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    genderLabel: {
        id: 'tdic.fnol.wc7.views.what.Gender',
        defaultMessage: 'Gender'
    },
    maritalStatus: {
        id: 'tdic.fnol.wc7.views.what.Marital status',
        defaultMessage: 'Marital status'
    },
    dateOfHire: {
        id: 'tdic.fnol.wc7.views.what.Date of Hire',
        defaultMessage: 'Date of Hire'
    },
    employmentStatus: {
        id: 'tdic.fnol.wc7.views.what.Employment status',
        defaultMessage: 'Employment status'
    },
    occupation: {
        id: 'tdic.fnol.wc7.views.what.Occupation/Job Title',
        defaultMessage: 'Occupation/Job Title'
    },
    grossWeeklyWage: {
        id: 'tdic.fnol.wc7.views.what.Gross Weekly Wage',
        defaultMessage: 'Gross Weekly Wage'
    },
    selectGenderLabel: {
        id: 'tdic.fnol.wc7.views.what.Select Gender',
        defaultMessage: '-- Select Gender --'
    },
    employeeAddress1: {
        id: 'tdic.fnol.wc7.views.what.Employee Address Line 1',
        defaultMessage: 'Employee Address Line 1'
    },
    employeeAddress2: {
        id: 'tdic.fnol.wc7.views.what.Employee Address Line 2',
        defaultMessage: 'Employee Address Line 2'
    },
    whatName: {
        id: 'tdic.fnol.wc7.views.what.Name',
        defaultMessage: 'Name'
    },
    reportedBy: {
        id: 'tdic.fnol.wc7.views.what.Reported By',
        defaultMessage: 'Reported By'
    },
    whereLocation: {
        id: 'tdic.fnol.common.directives.loss-location.Location',
        defaultMessage: 'Location'
    },
    whereInjury: {
        id: 'tdic.fnol.common.directives.loss-location.Where did this Injury occur?',
        defaultMessage: 'Where did this Injury occur?'
    },
    primaryInjuryNature: {
        id: 'tdic.fnol.wc7.views.injury.Primary Injury Type',
        defaultMessage: 'Primary Injury Type'
    },
    primaryInjuryNaturePlaceholder: {
        id: 'tdic.fnol.wc7.views.injury.Select Primary Injury Type',
        defaultMessage: 'Select Primary Injury Type'
    },
    detailedInjuryNature: {
        id: 'tdic.fnol.wc7.views.injury.Detailed Injury Type',
        defaultMessage: 'Detailed Injury Type'
    },
    detailedInjuryNaturePlaceholder: {
        id: 'tdic.fnol.wc7.views.injury.Select Detailed Injury Type',
        defaultMessage: 'Select Detailed Injury Type'
    },
    invalidDateMessage: {
        id: 'tdic.fnol.wc7.views.injury.Date of Injury has to be a date in between Date of Loss and Date Reported',
        defaultMessage: 'Date of Injury has to be a date in between Date of Loss and Date Reported'
    }
});
